import React from 'react';
import NavBar from '../components/NavBar';

const PaymentFailure = () => (
  <>
    <NavBar />
    <div className="checkout-container">
      <div className="checkout-header">
        <h3> לא עבד :( תנסי שוב...</h3>
      </div>
      <div className="checkout-message" style={{ color: 'crimson', fontWeight: 700, fontSize: '1.2rem' }}>
        זה מעצבן, אבל זה קורה לפעמים - התשלום לא עבר. אנא נסי שוב או פני אלינו לעזרה.
      </div>
      <div style={{ marginTop: 32 }}>
        <a href="/profile/cart" className="pay-btn">מכאן חוזרים לסל</a>
        <a href="/" className="cancel-btn" style={{ marginLeft: 12 }}>לדף הבית</a>
      </div>
    </div>
  </>
);

export default PaymentFailure;